import { atom } from "recoil";

export const authTokenAtom = atom({
  key: "authTokenAtom",
  default: "",
});
